// extracted by mini-css-extract-plugin
module.exports = {"title-text":"ChatQueueForm_title-text__18nBr","actionButton":"ChatQueueForm_actionButton__1mYji","buttonText":"ChatQueueForm_buttonText__5UGzB"};